import { render, staticRenderFns } from "./dial1.vue?vue&type=template&id=c2f656e2&scoped=true"
import script from "./dial1.vue?vue&type=script&lang=js"
export * from "./dial1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f656e2",
  null
  
)

export default component.exports